import _range from "lodash/range";
import _map from "lodash/map";
import { IOption } from "component-library";
import { FilterType } from "hoc/withJobsFilter/withJobsFilter.config";

export function getTagName(translation: string, value: string) {
  return `${translation}: ${value}`;
}

export function getTagId(filterType: FilterType, optionId: string = "") {
  return `${filterType}_${optionId}`;
}

interface IYearsOptionsInterface {
  emptyLabel: string;
  yearLabel: string;
  yearsLabel: string;
}

export function getYearsOptions(
  from: number,
  to: number,
  { emptyLabel, yearLabel, yearsLabel }: IYearsOptionsInterface
): IOption<number>[] {
  const rangeOfYears = _map(_range(from, to + 1), (year) => {
    return {
      name: `${year} ${year > 1 ? yearsLabel : yearLabel}`,
      value: year,
    };
  });

  return [{ name: emptyLabel, value: NaN }, ...rangeOfYears];
}
